import React, { useState } from "react";
import {
  TextField,
  Typography,
} from "@mui/material";
import { AdminAPIHandler } from "../../../../services/NetworkClient/BackendAPIs/AdminAPIHandler";
import { ErrorLogger } from "../../../../utils/Logger";
import GGLoaderButton from "../../../CommonComponents/GGLoaderButton/GGLoaderButton";
import { Payment } from "../../../../Models/Payment";
import AdminPaymentEditableDetailsSection from "../AdminPaymentEditableDetailsSection/AdminPaymentEditableDetailsSection";


const AdminManagePaymentById: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [paymentId, setPaymentId] = useState("");
  const [payment, setPayment] = useState<Payment | undefined>(undefined);
  const [error, setError] = useState("");

  const fetchPayment = async () => {
    setLoading(true);
    setError("");
    try {
      const payment = await AdminAPIHandler.shared.getPaymentById(paymentId);
      if (payment){
        setPayment(payment);
      } else {
        throw new Error("Payment not found")
      }
    } catch (error) {
      setPayment(undefined);
      setError(error as string);
      ErrorLogger.log(error, 'AdminManagePaymentById.fetchPayment');
    }
    setLoading(false);
  };

  return (
    <div className="admin-manage-order-by-id-section">
      <div className="fetch-btn-container">
        <TextField label='Enter Payment Id' fullWidth value={paymentId} onChange={(e: any) => setPaymentId(e.target.value)}>  </TextField>
        <GGLoaderButton title="Fetch Payment" isLoading={loading} onClick={fetchPayment}>Fetch Payment</GGLoaderButton>
      </div>
      <Typography color={'error'}>{error}</Typography>

      <div className="orders-container">
        { payment &&  <AdminPaymentEditableDetailsSection payment={payment} /> }
      </div>
    </div>
  );
};

export default AdminManagePaymentById;
